import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/tasks/task/taskAdvancement/styles.scss';export default {
  "taskAdvancement": "_taskAdvancement_a3jhp_1",
  "bar": "_bar_a3jhp_9",
  "late": "_late_a3jhp_18",
  "completed": "_completed_a3jhp_22"
};